


























































































































































import Vue from "vue";
import { mapState } from "vuex";
import { getIconForRole } from "@/utils";
import { ATable } from "@canvas/componentlibrary";
import CellRenderer from "../TableRenderers/NameRenderer.vue";
import { get, post } from "@/api";
import { http } from "@canvas/api";
import store from "../../store";
import { today, formatCurrency } from "../../../src/utils";
export default Vue.extend({
  name: "CashDocumentsTable",
  components: {
    ATable,
  },
  props: {
    wallet: {
    type: Object,
    default: () => ({}),
  },
},
  data() {
    return {
      isLoading: false,
      cashDocumentsData: [],
      tableData:[],
      cashCollectedCols: [
        {
          name: "id",
          display_name: "REQUEST ID",
          width: 25,
          height: 100,
          cellrenderer: CellRenderer,
        },
        {
          name: "createdBy",
          display_name: "CREATED BY",
          width: 25,
          cellrenderer: CellRenderer,
        },
        {
          name: "createdAt",
          display_name: "CREATED AT",
          width: 25,
          cellrenderer: CellRenderer,
        },
        {
          name: "depositedOn",
          display_name: "Deposited On",
          width: 25,
          height: 100,
          cellrenderer: CellRenderer,
        },
        {
          name: "amount",
          display_name: "AMOUNT",
          width: 25,
          height: 100,
          cellrenderer: CellRenderer,
        },
        {
          name: "gringotts_file_id",
          display_name: "FILE",
          width: 25,
          height: 100,
          cellrenderer: CellRenderer,
        },
        {
          name: "status",
          display_name: "STATUS",
          width: 25,
          height: 100,
          sortable:true,
          cellrenderer: CellRenderer,
        },
        {
          name: "comments",
          display_name: "COMMENT",
          width: 25,
          height: 100,
          cellrenderer: CellRenderer,
        },
        
      ],
      title: "Cash Documents",
      page: 0,
      pagecount: 1,
      selectedRow: null,
      fileList: [],
      fileUrl: "",
      totalCount:0,
      id: null,
      file: null,
      filePreview: "",
      form: {
        amount: "",
        depositDate: "",
        pid: "",
        referenceFile: null,
      },
      fetchSize:10,
      currentPage:0,
      is_next_page_count: 10,
      is_next_page_start: 0,
      sortorder: "desc",
      sortby: "createdAt",
      isModalVisible: false,
      newCashDocument: {
        amount: "",
        createdAt: "",
        depositedOn: "",
        fileUpload: "",
        file_url: "",
      },
      message: "",
      acceptedFileTypes: ".jpg,.jpeg,.png,.pdf", // Specify allowed file types
      pagination: {
        currentPage: 0, // Current page
        totalItems: 0, // Total items in the dataset
        fetchSize: 10, // Items per page
      },
    };
  },
  computed: {
    ...mapState("uiModule", {
      isOnMobileDevice: "isOnMobileDevice",
    }),
    ...mapState("appModule", {
      selectedEc: "selectedEc",
    }),
    buttonStyles() {
      return {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 20px",
      };
    },
    totalPages() {
      return Math.ceil((this as any).totalCount / (this as any).fetchSize);
    },
    todayDate() {
      return today();
    },
    isSubmitDisabled() {
      return (
        !(this as any).form.amount ||
        !(this as any).form.pid ||
        !(this as any).form.depositDate
      );
    },
  },
  methods: {
    changePage(newPage: any) {
      const totalPages = Math.ceil(
        (this as any).totalCount / (this as any).fetchSize
      );

      if (newPage < 0 || newPage >= totalPages) return;

      (this as any).currentPage = newPage;
      const pageType =
        newPage > (this as any).currentPage
          ? "next"
          : newPage < (this as any).currentPage
          ? "prev"
          : "current";
      (this as any).fetchData(pageType);
    },
    async fetchData(pageType = "current") {
      try {
        (this as any).$store.commit("uiModule/showLoadingModal", null, { root: true });
        let start;
        if (pageType === "next") {
          start = (this as any).is_next_page_start;
        } else if (pageType === "prev") {
          start = Math.max(
            0,
            (this as any).is_next_page_start - (this as any).is_next_page_count
          );
        } else {
          start = (this as any).currentPage * (this as any).fetchSize;
        }
        const paginatedQuery = `tags:EC:${store.state.appModule.selectedEc?.name};steps.name:${
          store.state.appModule.config?.ecFinanceManager
        };request_types:${store.state.appModule.config?.cashDepositType}&start=${start}&count=${
          (this as any).fetchSize
        }`;

        const response: any = await get({
          endpoint: "core.workflow.api.v1.requests",
          query: paginatedQuery,
        });
        (this as any).tableData = response?.items?.map(
          (item: any) => ({
              id: item.request_slug,
              gringotts_file_id: item.document?.attachments?.[0],
              createdAt : new Date(item.created_at).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              }),
              createdBy:item?.metadata?.createdBy,
              status: item.status == 'OPEN' ? 'PENDING' : item.status,
              amount: item.document?.amount == 0 ? 0 : item.document?.amount,
              comments: item?.metadata?.comment ?? '--',
              depositedOn: new Date(item.document?.transactionDate).toLocaleDateString(
                "en-GB",
                {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                }
              ),
              fileUpload:
                item?.document.transactionContexts?.filter(
                  (each: any) => each?.attributeName === "Cash Document File"
                )[0]?.attributeValue ?? null, // Placeholder or actual file link
            })
        ) || [];
        (this as any).totalCount = response?.total_count || 0;
        (this as any).filteredData = (this as any).tableData;
        (this as any).tableDataKey += 1;
        (this as any).is_next = response.is_next;
        (this as any).is_next_page_count = response?.is_next_page_count;
        (this as any).is_next_page_start = response?.is_next_page_start;
      } catch (error) {
        (this as any).$store.dispatch("uiModule/addToast", {
            severity: "error",
            message: "Failed to load cash deposits",
          });
      } finally {
        (this as any).$store.commit("uiModule/hideLoadingModal", null, { root: true });
      }
    },
    getIconForRole,
    formatCurrency,
    onFileInputChange(event: any) {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        (this as any).file = selectedFile;
        (this as any).filePreview = URL.createObjectURL(selectedFile);
      }
    },
    async handleFileUpload(file: any) {
      if (!file.name) return;
      try {
        const preSignedUrlRes: any = await get({
          endpoint: "gringotts.api.v1.attachment.presignedUploadUrl",
          file_name: file.name,
        });

        if (
          preSignedUrlRes.status.statusType === "SUCCESS" &&
          preSignedUrlRes?.attachmentModelList
        ) {
          const preSignedUrl =
            preSignedUrlRes?.attachmentModelList[0]?.preSignedUploadUrl;

          const uploadResponse: any = await fetch(preSignedUrl, {
            method: "PUT",
            body: file,
            headers: {
              "Content-Type": file.type,
            },
          });
          (this as any).id = preSignedUrlRes?.attachmentModelList[0]?.id;
          (this as any).fileUrl = preSignedUrlRes?.attachmentModelList[0]?.path;
        }
      } catch (error) {
        (this as any).message = `Error: ${error.message} unable to upload`;
      }
    },
    openModal() {
      (this as any).isModalVisible = true;
    },
    closeModal() {
      (this as any).file = null;
      (this as any).filePreview = "";
      (this as any).form = {
        amount: "",
        depositDate: "",
        pid: "",
        referenceFile: null,
      };
      (this as any).isModalVisible = false;
    },
    async handleModalSubmit() {
      try {
        (this as any).isLoading = true;
        if ((this as any).form.amount < 1) {
          alert("Please enter amount greater than 0");
          return;
        }
        if (
          !(this as any).form.amount ||
          !(this as any).form.depositDate ||
          !(this as any).file
        ) {
          throw new Error("Required form fields are missing");
        }
        if ((this as any).file) {
          await (this as any).handleFileUpload((this as any).file);
        }

        const payload: any = {
          "request_type": store.state.appModule.config?.cashDepositType,
          "document": {
            "status": "DEPOSITED",
            "currency": "INR",
            "country": "IN",
            "referenceId": Date.now(),
            "clientName": "ec_store_cash",
            "requestType": "CASH_CHEQUE_DEPOSIT_TRANSACTION",
            "amount": (this as any).form.amount,
            "walletId": store.state.appModule.selectedEc?.cash_wallet_id,
            "payMethod": {
                "name": "cash",
                "mode": "OFFLINE"
            },
            ...((this as any).id ? { attachments: [(this as any).id] } : {}),
            "transactionContexts": [
              {
                "attributeName": "Cash Document File",
                "attributeValue": (this as any).fileUrl,
                "valueType": "STRING"
              },
            ],
            "transactionDate": (this as any).form.depositDate
          },
          "metadata":{
            "createdBy":  store.state.appModule.loggedInUser.name,
            "fileId": (this as any).id,
            "fileUrl":  (this as any).fileUrl,
             "key18": "test 2"
          },
          "tags" :[
            `EC:${store.state.appModule.selectedEc?.name}`,
            `CREATED_BY:${store.state.appModule.loggedInUser.name?.toLowerCase()}`,
            `CREATED_AT:${new Date().toISOString().split('T')[0]}`,
            `TRANSACTION_DATE:${(this as any).form.depositDate}`,
            `AMOUNT:${(this as any).form.amount}`
          ]
        };

        const res = await post({
          endpoint: "workflow.api.v1.requests",
          body: payload,
        });
      
      setTimeout(async () => {
        await (this as any).fetchData();
        (this as any).closeModal();
        (this as any).isLoading = false;
        (this as any).$emit("fetchSummary");
      }, 1000);
      } catch (error) {
        (this as any).isLoading = false;
      }
    },
    formatDate(date: any) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    handlePageChange(page: number) {
      (this as any).pagination.currentPage = page;
      (this as any).fetchData(page);
    },
    handleSort(sortBy?: string) {
      if (sortBy === (this as any).sortby) {
        (this as any).sortorder =
          (this as any).sortorder === "asc" ? "desc" : "asc";
      } else {
        (this as any).sortorder = "desc";
      }
      (this as any).sortby = sortBy;
      (this as any).fetchData();
    },
  },
  watch: {
    selectedEc() {
      // Reload table data when EC changes
      (this as any).currentPage = 0;
      (this as any).fetchData();
    },
  },
  mounted() {
    (this as any).fetchData();
  },
});
